import { ConfigurationContextInterface } from './_configurationTypes';

export const CONFIGURATION_TYPE = {
  CONFIG: 'config',
  SETTINGS: 'settings'
};

export const configurationDefault: ConfigurationContextInterface = {
  config: {
    extensions: {
      login: '',
      sps: '',
      pbx: '',
      locks: 'false',
      sign: 'false',
      'high-contrast': false,
      duplicate: 'true',
      ticketrestore: 'true',
      filtersmemory: 'true',
      enforcepasswordchange: 'false'
    },
    app: '',
    code: '',
    modules: [],
    settings: {}
  }
};

export const configurationValues = {
  config: {
    extensions: {
      login: {
        basic: 'basic',
        ldap: 'ldap',
        kerberosLdap: 'kerberos_ldap'
      },
      sps: {
        ginis: 'ginis',
        geosps: 'geosps'
      },
      locks: {
        true: 'true',
        false: 'false'
      },
      sign: {
        true: 'true',
        false: 'false'
      },
      duplicate: {
        true: 'true',
        false: 'false'
      },
      ticketrestore: {
        true: 'true',
        false: 'false'
      },
      filtersmemory: {
        true: 'true',
        false: 'false'
      },
      enforcepasswordchange: {
        true: 'true',
        false: 'false'
      }
    }
  }
};

export const allModules = {
  daey: true,
  fkvv: true,
  kfhn: true,
  kqqs: true,
  olmr: true,
  qjlb: true,
  rxfm: true,
  rytw: true,
  wlot: true,
  gwwb: true
};



// WEBPACK FOOTER //
// ./src/components/provider/configuration/_configurationConstants.ts